export enum MapBoxStyle {
  Streets = 'mapbox://styles/mapbox/streets-v12',
  Outdoors = 'mapbox://styles/mapbox/outdoors-v12',
  Light = 'mapbox://styles/mapbox/light-v11',
  Dark = 'mapbox://styles/mapbox/dark-v11',
  Satellite = 'mapbox://styles/mapbox/satellite-v9',
  SatelliteStreets = 'mapbox://styles/mapbox/satellite-streets-v12',
  NavigationPreviewDay = 'mapbox://styles/mapbox/navigation-preview-day-v4',
  NavigationPreviewNight = 'mapbox://styles/mapbox/navigation-preview-night-v4',
  NavigationGuidanceDay = 'mapbox://styles/mapbox/navigation-guidance-day-v4',
  NavigationGuidanceNight = 'mapbox://styles/mapbox/navigation-guidance-night-v4',
  CustomLight = 'mapbox://styles/aventit/cm8prejag008g01qzd4sz69rc',
}
